import { type Type } from '@angular/core';
import { ExtractInputSignals, TTableRenderComponent } from '@dss-libs/shared/type/common-types';

/**
 * Builds a {@link TTableRenderComponent} with `inputFn` checked against the target component's
 * signal inputs. The stored type keeps a loose record because a column list mixes component
 * types; the check happens here, where `C` is still known.
 */
export function getRenderComponentType<T, C>(
  type: Type<C>,
  inputFn?: (row: T) => Partial<ExtractInputSignals<C>>
): TTableRenderComponent<T, C> {
  return inputFn ? { type, inputFn } : { type };
}
